// using default space values from styled-system
// --------------------0--1--2--3---4---5---6----7----8---
const defaultSpaces = [0, 4, 8, 16, 32, 64, 128, 256, 512];
export default defaultSpaces;
